/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IDescriptorBody } from '../../../descriptor';
import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface INumberNumberPacketDataMessage extends IPackageDataMessage {
	data: number;
	data1: number;
}

export default class NumberNumberPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.NUMBER, MessageDataTypes.NUMBER ) )();

	public static readonly DESCRIPTOR_NAME: string = 'NumberNumberPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = ( () => ( {
		fields: {
			data: {
				type: 'uint32',
				id: 1
			},
			data1: {
				type: 'uint32',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: number, public readonly data1: number ) {
		super();
	}

	public toJSON(): INumberNumberPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1
		};
	}

	public static fromJSON( data: INumberNumberPacketDataMessage ): NumberNumberPacketDataMessage {
		return new NumberNumberPacketDataMessage( data.data, data.data1 );
	}

	public static create( data: number, data1: number ): NumberNumberPacketDataMessage {
		return new NumberNumberPacketDataMessage( data, data1 );
	}
}
